import { render, staticRenderFns } from "./ManageNoticeEdit.vue?vue&type=template&id=b1eac158&scoped=true&lang=pug&"
import script from "./ManageNoticeEdit.vue?vue&type=script&lang=ts&"
export * from "./ManageNoticeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ManageNoticeEdit.vue?vue&type=style&index=0&id=b1eac158&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1eac158",
  null
  
)

export default component.exports